import * as Yup from "yup";

export const classSchema = Yup.object().shape({
    idActivity: Yup.string()
        .required("Selecione uma atividade"),
    idEmployee: Yup.string()
        .nullable()
        .notRequired(),
    idArea: Yup.string()
        .required("Selecione um local/área"),
    startTime: Yup.string()
        .required("Informe o horário de início"),
    durationMinutes: Yup.number()
        .typeError("A duração deve ser um número")
        .positive("A duração deve ser maior que zero")
        .required("Informe a duração da aula"),
    maxCapacity: Yup.number()
        .typeError("A capacidade deve ser um número")
        .integer("Deve ser um número inteiro")
        .positive("Deve ser maior que zero")
        .required("Informe a capacidade máxima"),
    startDate: Yup.string()
        .required("Informe a data de início da vigência"),
    endDate: Yup.string()
        .transform((value) => (value === "" ? null : value))
        .nullable()
        .notRequired(),
    weekdays: Yup.array()
        .when("id", {
            is: (id) => !id,
            then: (schema) => schema.min(1, "Selecione ao menos um dia da semana"),
            otherwise: (schema) => schema.nullable().notRequired()
        })
});
